/* Dwellio home behaviours: scroll reveal + FAQ accordion.
   Idempotent, and re-binds on Shopify theme-editor section loads. */
(function () {
  'use strict';

  function bindReveal(root) {
    var els = (root || document).querySelectorAll('.dwellio-chrome .reveal:not(.is-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  function bindFaq(root) {
    var qs = (root || document).querySelectorAll('.dwellio-chrome .faq__q');
    Array.prototype.forEach.call(qs, function (btn) {
      if (btn.dataset.dwBound) return;
      btn.dataset.dwBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq__item');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!item || !panel) return;
        var open = item.classList.contains('open');
        if (open) {
          btn.setAttribute('aria-expanded', 'false');
          item.classList.remove('open');
          panel.style.maxHeight = null;
        } else {
          btn.setAttribute('aria-expanded', 'true');
          item.classList.add('open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  function init(root) { bindReveal(root); bindFaq(root); }

  if (!window.__dwellioHomeInit) {
    window.__dwellioHomeInit = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    // Theme editor: re-bind when a section is added or re-rendered
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }
  window.dwellioHomeInit = init;
})();
